import heroBg from '@/assets/images/referrals/hero.png'
import ReferralByEmail from '../forms/referral-by-mail'
import { type ISendReferral } from '@/application/send-referral/use-send-referral'

export default function ReferralsHero({
  sendReferral,
  isLoading,
  success
}: {
  sendReferral: (params: ISendReferral) => void
  isLoading: boolean
  success: boolean
}) {
  return (
    <div
      className="group relative h-80 overflow-hidden rounded-xl p-3"
      id="referrals-hero"
    >
      <div
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat transition-all duration-1000 group-hover:scale-110"
        style={{
          backgroundImage: `url('${heroBg}')`
        }}
      />
      <ReferralByEmail
        sendReferral={sendReferral}
        isLoading={isLoading}
        success={success}
      />
    </div>
  )
}
